<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark bg-custom-2">
      <b-navbar-brand href="#">
        <b-img
          src="https://www.tearcell.com/media/images/tyrsell_logo_1.original.png"
          class="d-none d-sm-block"
          alt="logo"
        ></b-img>Safeharbour Builder
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{name: 'index'}">Customize Resources</b-nav-item>
          <b-nav-item :to="{name: 'coord'}">Change Coordinator</b-nav-item>
          <b-nav-item v-if="isLoggedIn" @click="logout">Logout</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <vue-confirm-dialog class="custom-modal"></vue-confirm-dialog>
    <router-view />
  </div>
</template>

<script>
export default {
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        //function (resolve, reject) {

        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },

  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>


<style>
#vueConfirm > div > div > button.vc-btn.left {
  color: #0069d9;
}
#vueConfirm > div > div > button.vc-btn {
  color: #c82333;
  background-color: #f7f7f7;
}

.navbar-brand {
  width: 150px;
  font-size: 24px;
}
.navbar-brand img {
  height: 30px;
  /* put value of image height as your need */

  margin-right: 10px;
}

.bg-custom-2 {
  background-image: linear-gradient(15deg, #13547a 0%, #80d0c7 100%);
}
</style>